import { newSpecPage } from '@stencil/core/testing';
import { NylasMinBookingNotice } from '../nylas-min-booking-notice';
import { h } from '@stencil/core';
import { SelectDropdown } from '../../../design-system/select-dropdown/select-dropdown';
import { TimePeriodSelector } from '../../../design-system/time-period-selector/time-period-selector';
import { InputDropdown } from '../../../design-system/input-dropdown/input-dropdown';
import { selectedConfiguration } from '@/utils/test-utils';

describe('nylas-min-booking-notice', () => {
  let nylasMinBookingNotice: NylasMinBookingNotice;
  let page: any;
  const config = selectedConfiguration;
  beforeEach(async () => {
    page = await newSpecPage({
      components: [NylasMinBookingNotice, TimePeriodSelector, SelectDropdown, InputDropdown],
      template: () => {
        return <nylas-min-booking-notice name="min-booking-notice" selectedConfiguration={config}></nylas-min-booking-notice>;
      },
    });
    nylasMinBookingNotice = page.rootInstance as NylasMinBookingNotice;
  });

  it('renders', async () => {
    expect(page.root).toMatchSnapshot();
  });

  it('selects default min booking notice', async () => {
    const minBookingNoticeInput = page.root.shadowRoot.querySelector('input-dropdown#time-number').shadowRoot.querySelector('input');
    expect(minBookingNoticeInput.value).toBe('1');
    const availableDaysPeriodButton = page.root.shadowRoot.querySelector('select-dropdown#time-period').shadowRoot.querySelector('button');
    expect(availableDaysPeriodButton.textContent).toBe('hour');
  });

  it('selects min booking notice', async () => {
    const spyEvent = jest.fn();
    nylasMinBookingNotice.valueChanged = {
      emit: spyEvent,
    };
    const mockEvent = new CustomEvent('timePeriodChanged', {
      detail: { number: 2, period: 'week' },
      bubbles: true,
      composed: true,
    });
    nylasMinBookingNotice.timePeriodChangedHandler(mockEvent);
    expect(spyEvent).toHaveBeenCalled();
  });
});
